export default "__VITE_ASSET__CBtdtKKT__"